import { TrmmAgentMesh, TrmmViewKind } from './trmm-agent-mesh.types';

export function DeviceViewer({
  mesh,
  view,
  iframeRef
}: {
  mesh: TrmmAgentMesh;
  view: TrmmViewKind;
  iframeRef?: (el: HTMLIFrameElement | null) => void;
}) {
  const src = mesh[view];
  return (
    <iframe
      ref={iframeRef}
      key={`${view}:${src}`}
      title={`Remote: ${view}`}
      src={src}
      style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
      allow="clipboard-read; clipboard-write; fullscreen"
    />
  );
}
